export default (risks, newGroupComponentRisk) => {
	const resp = risks.map((risk) => {
		if (risk.riskId === newGroupComponentRisk.primaryRiskId) {
			const newRisk = {
				...risk,
				rationale: newGroupComponentRisk.rationale === undefined ? null : newGroupComponentRisk.rationale,
				...newGroupComponentRisk,
				concurrencyToken: newGroupComponentRisk.concurrencyToken,
				rationaleModifyBy: newGroupComponentRisk.modifyUser,
				rationaleModifyDate: newGroupComponentRisk.modifyDate
			};

			return newRisk;
		}
		return risk;
	});
	return resp;
};
